import React from "react";
import { Message } from "react-message-context";

const InvalidError = ({ noLineBreaks }) => {
  const space = noLineBreaks ? <>&nbsp;</> : <br />;

  const normal = (
    <>
      <Message id="feedback.form.textArea.error.title" />
      {space}
      <Message id="feedback.form.textArea.error.text" />
    </>
  );
  const sr = (
    <>
      <Message id="feedback.form.textArea.error.title" />
      {space}
      <Message id="feedback.form.textArea.srError.text" />
    </>
  );

  return (
    <>
      <span aria-labelledby="ROF-srError">
        <span aria-hidden="true">{normal}</span>
      </span>
      <span id="ROF-srError" className="rof-srOnly">
        {sr}
      </span>
    </>
  );
};

export default InvalidError;
